export default class VippsUser {
    constructor(openid, name, given_name, family_name, phone_number, address, birthdate) {
      this.openid = openid;
      this.name = name;
      this.given_name = given_name;
      this.family_name = family_name;
      this.phone_number = phone_number;
      this.address = address;
      this.birthdate = birthdate;
    }
  }
